import { Pipe, PipeTransform } from '@angular/core';
//import { stringify } from '@angular/core/src/render3/util';

@Pipe({
  name: 'meetingType'
})

export class MeetingTypePipe implements PipeTransform {

  constructor() { }

  transform(value: number): string {
    const options: Array<{Text: string, Value: number}> = [
      { Text: 'réunion instantanée', Value: 1 },
      { Text: 'réunion', Value: 2 },
      { Text: 'réunion récurente sans heure fixe', Value: 3 },
      { Text: 'réunion récurente (à heure fixe)', Value: 8 },
      { Text: 'webinaire', Value: 5 },
      { Text: 'wébinaire récurent sans heure fixe', Value: 6 },
      { Text: 'webinaire récurent (à heure fixe)', Value: 9 },
    ];
    let text: string = '';
    for (let i: number = 0; i < options.length; i++) {
      if (value === options[i].Value) {
        text = options[i].Text;
      }
    }
    return text;
  }
}
